"use client";

import React from "react";
import { ChevronRight, Clock, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const locations = [{
  city: "Limassol",
  address: "Foloune House, Gladstonos 120, Unit 5, Limassol 3032\nEmail: bodywerkscy@gmail.com",
  phone: "Mobile, WhatsApp & Telegram: +357 96 117140\nLandline: +357 25 954 014",
  hours: ["Mon, Wed: 4:00 PM - 7:30 PM", "Tue, Thu: 9:30 AM - 12:30 PM", "Fri: 3:00 PM - 6:30 PM", "Closed Sat & Sun"],
  link: "/ContactPage"
}, {
  city: "Nicosia",
  address: "Alexiou Building, Ifigenias 62, 3rd Floor, Nicosia 2003",
  phone: "Mobile and Message: +357 99 433537",
  gmbProfile: "https://share.google/1C041bB4AuaWlZh5r",
  hours: ["By appointment only", "Book online or call +357 99 433537"],
  link: "/ContactPage"
}];
export default function DualCityCareCenters() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="dual-city-care-centers" className="bg-muted/30 py-16 md:py-24" ref={ref}>
      <div className="container mx-auto px-4 md:px-6">
        <div className={`mx-auto mb-12 max-w-3xl text-center transition-all duration-700 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <h2 className="font-serif text-3xl font-bold tracking-tight text-foreground md:text-4xl">
            Our Care Centers
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            Conveniently located in Limassol and Nicosia to serve you better.
          </p>
        </div>

        <div className="mx-auto grid max-w-5xl gap-8 md:grid-cols-2 lg:gap-12">
          {locations.map((location, i) => <Card key={location.city} data-index={i} className={`group flex flex-col border-none bg-card shadow-sm transition-all duration-700 hover:shadow-md ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <CardHeader className="pb-4">
                <div className="mb-4 inline-flex size-12 items-center justify-center rounded-full bg-accent/10">
                  <MapPin className="size-6 text-accent" />
                </div>
                <CardTitle className="font-serif text-2xl font-bold text-foreground">
                  {location.city}
                </CardTitle>
              </CardHeader>
              <CardContent className="flex-1 space-y-6 pb-6">
                <div className="flex items-start gap-3">
                  <MapPin className="mt-1 size-5 shrink-0 text-muted-foreground" />
                  <p className="text-base !text-[hsl(28,91%,54%)]">
                    {location.address}
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <Phone className="mt-1 size-5 shrink-0 text-muted-foreground" />
                  <p className="text-base !text-[hsl(28,91%,54%)]">
                    {location.phone}
                  </p>
                </div>
                {location.gmbProfile && <div className="flex items-start gap-3">
                    <MapPin className="mt-1 size-5 shrink-0 text-muted-foreground" />
                    <Link to={location.gmbProfile} newTab className="text-base text-accent hover:underline">
                      GMB Profile
                    </Link>
                  </div>}
                <div className="flex items-start gap-3">
                  <Clock className="mt-1 size-5 shrink-0 text-muted-foreground" />
                  <div className="space-y-1">
                    {location.hours.map((hourLine, idx) => <p key={idx} className="text-base text-foreground/80 !text-left">
                        {i === 0 ? location.hours[idx] : hourLine}
                      </p>)}
                  </div>
                </div>
              </CardContent>
              <CardFooter className="pt-0">
                <Button variant="link" className="h-auto p-0 text-accent hover:text-accent/80" asChild>
                  <Link to={location.link}>
                    View Location
                    <ChevronRight className="ml-1 size-4 transition-transform group-hover:translate-x-1" />
                  </Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}